import {Component, ElementRef, HostListener, inject, OnInit} from '@angular/core';
import {UserService} from "../../../services/user.service";
import {RoleService} from "../../../role/role.service";
import {Router} from "@angular/router";
import { AdminService } from '../../services/admin.service';
import { AdminMainComponent } from '../admin-main.component';

@Component({
    selector: 'app-admin-sidemenu',
    templateUrl: './admin-sidemenu.component.html',
    styleUrls: ['./admin-sidemenu.component.scss'],
    standalone: false
})
export class AdminSidemenuComponent implements OnInit {
  heading;

  company;

  private readonly adminMainComponent = inject(AdminMainComponent);

  private readonly eRef = inject(ElementRef);

  constructor(
    private userService: UserService,
    public roleService: RoleService,
    private router: Router,
    private adminService: AdminService
  ) { }

  ngOnInit() {
    this.heading = this.adminService.getText('location_plural');
    this.company = this.adminService.local$.getValue();
  }
  logout() {
    this.userService.logout();
    this.router.navigate(['admin','login']);
  }

  onSelect(): void {
    this.adminMainComponent?.sidebarOpened?.set(false);
  }

  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent): void {
    if(this.eRef.nativeElement.contains(event.target)) {
      event.stopPropagation();
      return;
    }

    if (this.adminMainComponent?.sidebarOpened) {
      this.adminMainComponent.sidebarOpened.set(false);
    }
  }
}
